/**
 * @file RegionInfo/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const VERTICAL_REGION_COUNT = 5;
export const SWIMLANE_REGION_COUNT = 4;
export const SWIMLANE_FEATURE = { name: "swimlane", instance: "local" };
export const VERTICAL_FEATURE = {
    name: "vertical-card-list",
    instance: "local",
};
